import parseImage from './lib/parsers/parse-image';
import { isPng, isGif, isBmp, isJpeg } from './lib/binary-image-api/binary-image-parsers';
var VERSION = typeof "2.0.4" !== 'undefined' ? "2.0.4" : 'latest';
var EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'ico', 'svg'];
var MIME_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/bmp', 'image/vndmicrosofticon', 'image/svg+xml'];
var ImageLoader = {
  name: 'Images',
  version: VERSION,
  mimeTypes: MIME_TYPES,
  extensions: EXTENSIONS,
  parse: parseImage,
  test: function test(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    return isJpeg(dataView) || isBmp(dataView) || isGif(dataView) || isPng(dataView);
  },
  options: {
    image: {
      format: 'auto',
      decodeHTML: true
    }
  }
};
export default ImageLoader;